import user from './user'
import chat from './chat'

export default {
  ...user,
  ...chat
}
